import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, input, output, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientService } from '@fitness-force/api';
import type { PlanSummary } from '@fitness-force/models';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { SkeletonModule } from 'primeng/skeleton';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChangeBilllingNameComponent } from '../change-billling-name/change-billling-name.component';

@Component({
  selector: 'billing-client-info',
  templateUrl: './billing-client-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AvatarModule,
    ShortNamePipe,
    SkeletonModule,
    PopoverModule,
    ButtonModule,
    ChangeBilllingNameComponent,
    TranslateModule,
    AsyncPipe,
    TitleCasePipe
]
})
export class BillingClientInfoComponent implements OnInit {
  private clientService = inject(ClientService);

  readonly showSkeleton$ = input(new BehaviorSubject<boolean>(true), { alias: "showSkeleton" });
  readonly planSummary$ = input.required<Observable<PlanSummary>>({ alias: "planSummarydata" });
  readonly ChangeBillingNameEvent = output<{
    billingName: string;
}>();
  
  showChangeBillingNameModel$ = new BehaviorSubject<boolean>(false);
  isRemoveBillingName:boolean=false;
  billingName:string="";

  ngOnInit(): void {
    console.log('BillingClientInfoComponent ngOnInit');
  }

  clientStatus(client: any): string {
    if (client && client.client_status)
      return this.clientService.getClientStatusHtml(
        client.client_status.toString()
      );
    else return '';
  }

  removeBillingName() {
    this.billingName="";
    this.ChangeBillingNameEvent.emit({billingName: this.billingName})
  }

  
  closeChangeBillingNameDialogEvent(event:{hidePopup: boolean;billingName: string})
  {
    this.showChangeBillingNameModel$.next(false);
    this.billingName= event.billingName;
    this.ChangeBillingNameEvent.emit({billingName: this.billingName})
  }

}
